import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import CtaBanner from "../components/CtaBanner";
import Hoofdpartner from "../components/Hoofdpartner";
import Sponsors from "../components/Sponsors";
import { IMAGES } from "../data/site";

const features = [
  { title: "Frisse drankjes", text: "Cocktails, mocktails en zomerse favorieten." },
  { title: "Gezellige avonden", text: "Zomerse muziek en de zonsondergang boven het Douaneplein." },
  { title: "Foodtrucks", text: "Lekker eten met je voeten in het zand." },
  { title: "Voor iedereen", text: "Afterworks, families, dates of een avondje met vrienden." },
];

const gallery = [
  IMAGES.strandbarGal06,  // young man with aperol spritz at table
  IMAGES.strandbarNew04,  // palmboom strandbar
  IMAGES.strandbarGal07,  // bartender with beer tray, purple lights
  IMAGES.strandbarNew02,  // foodtruck / platter
  IMAGES.strandbarNew05,  // bartender pour
  IMAGES.strandbarGal08,  // older couple cheers with drinks
];

export default function Strandbar() {
  return (
    <>
      <Seo
        title="Strandbar | Mechelen Beach 2026"
        description="Geniet van zomerse sfeer, frisse drankjes en gezellige momenten aan de strandbar van Mechelen Beach 2026."
      />

      <PageHero
        eyebrow="Strandbar"
        title="De zomerse ontmoetingsplek van Mechelen"
        subtitle="Ook in 2026 wordt de strandbar opnieuw dé plek om te genieten van frisse drankjes, zomerse sfeer en gezellige momenten. Kom langs met vrienden, familie of collega's."
        image={IMAGES.strandbarNew03}
        imageAlt="Strandbar Mechelen Beach — sfeerbeeld onder de stretch tent"
        primaryCta={{ label: "Bekijk programma", to: "/programma" }}
        secondaryCta={{ label: "Contacteer ons", to: "/contact" }}
      />

      {/* Wat te beleven */}
      <section className="bg-[#fdf8ec] py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="photo">
              <img src={IMAGES.strandbarNew01} alt="Bartender aan de strandbar van Mechelen Beach" className="w-full h-[360px] sm:h-[460px] object-cover" />
            </div>
            <div>
              <span className="eyebrow">Wat te beleven</span>
              <h2 className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#2b1c10] leading-[1.05]">
                Cocktails, sfeer en zomeravonden
              </h2>
              <p className="mt-5 text-base sm:text-lg text-[#6b5945] leading-relaxed">
                Vanaf de eerste zonnestraal tot diep in de avond — de strandbar
                is de plek waar zomer echt zomer wordt. Foodtrucks, gezellige
                muziek en de zonsondergang boven het Douaneplein.
              </p>
              <div className="mt-8 grid grid-cols-2 gap-4">
                {features.map((f, i) => (
                  <div
                    key={f.title}
                    data-testid={`strandbar-feature-${i}`}
                    className="bg-white rounded-xl border border-[#ebd9b5] p-4"
                  >
                    <p className="font-display font-semibold text-[#2b1c10]">{f.title}</p>
                    <p className="mt-1 text-xs text-[#6b5945] leading-relaxed">{f.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sfeerbeelden */}
      <section className="bg-sand-2 py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl">
            <span className="eyebrow">Sfeerbeelden</span>
            <h2 className="font-display mt-5 text-3xl sm:text-4xl font-semibold tracking-tight text-[#2b1c10]">
              Beelden van de strandbar
            </h2>
          </div>
          <div className="mt-10 grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4">
            {gallery.map((src, i) => (
              <div key={i} data-testid={`strandbar-gallery-${i}`} className="overflow-hidden rounded-xl aspect-square group">
                <img
                  src={src}
                  alt={`Strandbar sfeer ${i + 1}`}
                  className="w-full h-full object-cover group-hover:scale-[1.06] transition-transform duration-700"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section data-testid="strandbar-hoofdpartner" className="bg-[#fdf8ec] py-14 sm:py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight text-[#2b1c10]">
              Hoofdpartner
            </h2>
          </div>
          <div className="mt-8">
            <Hoofdpartner showLabel={false} />
          </div>

          <div className="mt-14">
            <div className="text-center max-w-2xl mx-auto">
              <h3 className="font-display text-xl sm:text-2xl font-semibold tracking-tight text-[#2b1c10]">
                Algemene partners
              </h3>
            </div>
            <div className="mt-8">
              <Sponsors />
            </div>
          </div>
        </div>
      </section>

      <CtaBanner
        title="Klaar voor een zomerse avond?"
        text="Verken het volledige programma van Mechelen Beach 2026."
        primaryCta={{ label: "Bekijk programma", to: "/programma" }}
        image={IMAGES.strandbarNew03}
      />
    </>
  );
}
